<template>
  <div class="indexContainer">
    <Header></Header>
    <img class="titleTop" src="../../assets/img/suggestion/banner.png" alt="" />
    <!-- <Suggest></Suggest> -->
    <!-- <div class="content">
      <div class="contentSug">
        <label>反馈对象</label>
        <input type="radio" name="radios" value="1" v-model="param">
        <span>司机</span>
        <input type="radio" name="radios" value="2" v-model="param">
        <span>货主</span>
      </div>
      <div class="contentSug">
        <label>反馈对象</label>

      </div>
    </div> -->
    <div class="content">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="反馈对象" prop="resource">
          <el-radio-group v-model="ruleForm.resource">
            <el-radio label="司机"></el-radio>
            <el-radio label="货主"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="反馈内容" prop="sugContent"><el-input type="textarea" :rows="4" v-model="ruleForm.sugContent" placeholder="描述一下你的问题~~"></el-input></el-form-item>
        <div style="overflow: hidden;">
        <div style="width: 55%; float: left;height: 200px;">
        <el-form-item style="width: 76%;" label="姓名" prop="name"><el-input v-model="ruleForm.name" placeholder="请输入您姓名"></el-input></el-form-item>
        <el-form-item style="width: 76%;" label="手机号码" prop="phone"><el-input v-model="ruleForm.phone" placeholder="请输入手机号"></el-input></el-form-item>
        <el-form-item style="width: 76%;" label="邮箱" prop="email"><el-input v-model="ruleForm.email" placeholder="请输入邮箱"></el-input></el-form-item>
        </div>
        <el-form-item style="float: left;" label="上传图片" ref="uploadElement" prop="imageUrl">
          <el-input style="display: none;" v-model="ruleForm.imageUrl" v-if="false"></el-input>
          <el-upload
            class="avatar-uploader"
            ref="upload"
            :show-file-list="false"
            action="/index/upload"
            :before-upload="beforeUpload"
            :on-change="handleChange"
            :auto-upload="false"
            :data="ruleForm"
          >
            <img v-if="ruleForm.imageUrl" :src="ruleForm.imageUrl" class="avatar" />
            <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
            <img v-else src="../../assets/img/suggestion/picture.png" alt="" />
          </el-upload>
        </el-form-item>
        </div>
        <el-form-item style="text-align: center;margin-left: 0;">
          <el-button type="primary" :plain="true" @click="submitForm('ruleForm')">提交反馈</el-button>
          <!-- <el-button type="primary" @click="submitForm('ruleForm')">提交反馈</el-button> -->
          <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../../components/common/header.vue';
import Footer from '../../components/common/footer.vue';
// import Suggest from '../../components/common/suggest.vue';
export default {
  components: {
    Header,
    Footer,
    // Suggest
  },
  data() {
    return {
      param: '1',
      ruleForm: {
        name: '',
        phone: '',
        email: '',
        imageUrl: '',
        resource: '',
        sugContent: ''
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        sugContent: [{ required: true, message: '请填写你的问题~~', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        imageUrl: [{ required: false, message: '请上传图片', trigger: 'blur' }],
        resource: [{ required: true, message: '请选择反馈对象', trigger: 'change' }]
      }
    };
  },
  created: function() {},
  methods: {
    submitForm(formName) {
      let vm = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          //vm.$refs.upload.submit();
          this.$message({
            message: '恭喜你，反馈成功',
            type: 'success'
          });
          this.$refs[formName].resetFields();
          this.ruleForm.imageUrl = '';
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm.imageUrl = '';
    },

    handleChange(file, fileList) {
      this.ruleForm.imageUrl = URL.createObjectURL(file.raw);
    },

    beforeUpload(file) {
      return true;
    },
  },
  computed: {},
  mounted: function() {}
};
</script>

<style scoped>
.titleTop {
  width: 100%;
}
.content {
  padding: 30px 80px;
  width: 1000px;
  margin: 40px auto;
  background-color: #f7f7f7;
}
.contentSug label {
  width: 90px;
}
.avatar-uploader input[type='file'] {
  display: none !important;
}
.el-upload__input {
  display: none !important;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.el-input__inner {
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/haveSug.vue